import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdDelete } from "react-icons/md";
import { FaMale, FaFemale } from "react-icons/fa";
import moment from "moment";
import { EditButton, ModalContent, ModalHeader, ModalRow, ModalRowLabel, ModalRowValue, ModalSection, ScrollableContent } from "../Styles/InputStyles";
import { ProfileSection, UserInfo } from "../Styles/PageStyles";
import { getLeadRentRange, getLeadSource } from "../../helpers";
import Config, { leadStatusConfig } from "../../Config";

const getValueOrDashedIcon = (value) => {
    if (value === null || value === undefined || value === "Invalid date" || value === "") {
        return <span className="text-gray-400">-</span>;
    }
    return value;
};

const getValidDateOrDashedIcon = (date) => {
    if (!date) {
        return <span className="text-gray-400">-</span>;
    }

    const formattedDate = moment(date);

    if (!formattedDate.isValid()) {
        return <span className="text-gray-400">—</span>;
    }

    return formattedDate.format("DD-MMM-YY");
};

// const getStatus = (status) => {
//     if (status === 1) {
//         return <p className="bg-blue-50 text-blue-700 text-xs border-blue-100 border w-24 h-7 flex items-center justify-center rounded-lg">New</p>;
//     } else if (status === 2) {
//         return <p className="bg-yellow-50 text-yellow-700 text-xs border-yellow-100 border w-24 h-7 flex items-center justify-center rounded-lg">Follow Up</p>;
//     } else if (status === 3) {
//         return <p className="bg-green-50 text-green-700 text-xs border-green-100 border w-24 h-7 flex items-center justify-center rounded-lg">Visit Scheduled</p>;
//     } else if (status === 4) {
//         return <p className="bg-purple-50 text-purple-700 text-xs border-purple-100 border w-24 h-7 flex items-center justify-center rounded-lg">Visit Done</p>;
//     } else if (status === 5) {
//         return <p className="bg-teal-50 text-teal-700 text-xs border-teal-100 border w-24 h-7 flex items-center justify-center rounded-lg">Moved In</p>;
//     } else if (status === 6) {
//         return <p className="bg-gray-50 text-gray-700 text-xs border-gray-100 border w-24 h-7 flex items-center justify-center rounded-lg">Not Interested</p>;
//     } else if (status === 7) {
//         return <p className="bg-amber-50 text-amber-700 text-xs border-amber-100 border w-24 h-7 flex items-center justify-center rounded-lg">Contacted</p>;
//     } else if (status === 8) {
//         return <p className="bg-lime-50 text-lime-700 text-xs border-lime-100 border w-24 h-7 flex items-center justify-center rounded-lg">Interested</p>;
//     } else if (status === 9) {
//         return <p className="bg-emerald-50 text-emerald-700 text-xs border-emerald-100 border w-24 h-7 flex items-center justify-center rounded-lg">Invalid</p>;
//     } else if (status === 10) {
//         return <p className="bg-cyan-50 text-cyan-700 text-xs border-cyan-100 border w-24 h-7 flex items-center justify-center rounded-lg">Onhold</p>;
//     } else if (status === 11) {
//         return <p className="bg-sky-50 text-sky-700 text-xs border-sky-100 border w-24 h-7 flex items-center justify-center rounded-lg">Not Answered</p>;
//     } else if (status === 12) {
//         return <p className="bg-sky-50 text-red-700 text-xs border-red-100 border w-24 h-7 flex items-center justify-center rounded-lg">Lost</p>;
//     } else {
//         return <p className="bg-gray-50 text-gray-700 text-xs border-gray-100 border w-24 h-7 flex items-center justify-center rounded-lg">Unknown</p>;
//     }
// };

const getStatus = (item) => {
    const status = leadStatusConfig[item] || {
        label: "Other",
        color: "text-gray-500",
    };

    return (
        <div>
            <span className={`text-sm font-semibold ${status.color}`}>
                {status.label}
            </span>

            {status.showVisitDate && item.visitDateTime && (
                <div className="text-xs text-gray-500">
                    {moment(item.visitDateTime).format("DD MMM YY, hh:mm A")}
                </div>
            )}
        </div>
    );
};

const NoteItem = ({ name, time, description }) => {
    time = time ? moment(time).format('DD, MMM YY, hh:mm A') : time;
    const [showFullDescription, setShowFullDescription] = React.useState(false);
    const shouldTruncate = description?.length > 50;
    if (!description)
        return (<div className="bg-white rounded-lg mb-2"></div>);
    return (
        <div className="bg-gray-100 p-3 rounded-lg mb-2">
            <div className="flex justify-between items-center mb-1">
                <span className="text-sm  text-gray-600">By <span className="font-medium text-primary-color">{name}</span></span>
                <span className="text-xs text-gray-600">{time}</span>
            </div>
            <p className="text-sm text-gray-600">
                {showFullDescription ? description : shouldTruncate ? `${description.substring(0, 50)}...` : description}
            </p>
            {shouldTruncate && (
                <button
                    onClick={() => setShowFullDescription(!showFullDescription)}
                    className="text-xs text-blue-500 mt-1 text-right"
                >
                    {showFullDescription ? "Show less" : "Show more"}
                </button>
            )}
        </div>
    );
};

const ViewLead = ({
    setViewDetail,
    selectedData,
    setIsShowEditLead,
    setIsShowDeleteLead
}) => {
    const onClose = () => {
        setViewDetail(false);
    };

    const onDeleteClick = () => {
        setViewDetail(false);
        setIsShowDeleteLead(true);
    };

    const onEditBasicDetails = () => {
        setViewDetail(false);
        setIsShowEditLead(true);
    };
    const BADGE_BY_COLOR = {
        "text-blue-500": "bg-blue-100 text-blue-700 border-blue-300",
        "text-yellow-500": "bg-yellow-100 text-yellow-700 border-yellow-300",
        "text-indigo-500": "bg-indigo-100 text-indigo-700 border-indigo-300",
        "text-purple-500": "bg-purple-100 text-purple-700 border-purple-300",
        "text-emerald-600": "bg-emerald-100 text-emerald-700 border-emerald-300",
        "text-green-600": "bg-green-100 text-green-700 border-green-300",
        "text-lime-600": "bg-lime-100 text-lime-700 border-lime-300",
        "text-amber-500": "bg-amber-100 text-amber-700 border-amber-300",
        "text-orange-500": "bg-orange-100 text-orange-700 border-orange-300",
        "text-slate-500": "bg-slate-100 text-slate-700 border-slate-300",
        "text-gray-500": "bg-gray-100 text-gray-700 border-gray-300",
        "text-rose-500": "bg-rose-100 text-rose-700 border-rose-300",
        "text-red-600": "bg-red-100 text-red-700 border-red-300",
    };

    const BASE_BADGE_CLASS =
        "inline-flex items-center justify-center text-xs border rounded-full px-3 py-0.5 h-7 whitespace-nowrap";

    const getStatusBadge = (status) => {
        const config = leadStatusConfig[status] || {
            label: "Not Assigned",
            color: "text-gray-500",
        };

        const badgeClasses =
            BADGE_BY_COLOR[config.color] ||
            "bg-gray-100 text-gray-600 border-gray-300";

        return (
            <span className={`${BASE_BADGE_CLASS} ${badgeClasses}`}>
                {config.label}
            </span>
        );
    };
    return (
        <Container>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Lead Detail</h1>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <ProfileSection className="flex justify-between">
                <UserImageWrapper>
                    {selectedData.gender === 1 ? (
                        <FaMale className="text-gray-400 w-8 h-8" />
                    ) : (
                        <FaFemale className="text-gray-400 w-8 h-8" />
                    )}
                    <div className="flex flex-col gap-1">
                        <span className="text-gray-600 text-sm font-medium">
                            {selectedData?.name?.charAt(0).toUpperCase() + selectedData?.name?.slice(1)}{" "}
                        </span>
                        <span className="text-gray-400 text-xs">#{selectedData?.mobile || 'N/A'}</span>
                    </div>
                </UserImageWrapper>
                <div className="flex gap-2 items-center">
                    {/* <span>{getStatus(selectedData?.status)}</span> */}
                    <span>{getStatusBadge(selectedData?.status)}</span>
                    <MdDelete
                        size={20}
                        className="text-rose-500 cursor-pointer"
                        title="Delete Lead"
                        onClick={onDeleteClick}
                    />
                </div>
            </ProfileSection>

            <ModalContent>
                <ScrollableContent>
                    <Wrapper>
                        <BtnWrapper>
                            <SectionTitle>Basic Details</SectionTitle>
                            <EditButton title="Edit Basic Detail" onClick={onEditBasicDetails}>
                                Edit
                            </EditButton>
                        </BtnWrapper>

                        <ModalSection className="mb-3">
                            <ModalRow className="pb-4">
                                <FlexCol>
                                    <ModalRowLabel>Rent Range</ModalRowLabel>
                                    <ModalRowValue>{getLeadRentRange ? getLeadRentRange(selectedData?.rentRange) : getValueOrDashedIcon(selectedData?.rentRange)}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Source</ModalRowLabel>
                                    <ModalRowValue>{getLeadSource ? getLeadSource(selectedData?.source) : getValueOrDashedIcon(selectedData?.source)}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            <ModalRow>
                                <FlexCol className="pb-4">
                                    <ModalRowLabel>Visit Date & Time</ModalRowLabel>
                                    <ModalRowValue>
                                        {selectedData?.visitDateTime
                                            ? moment(selectedData.visitDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD, MMM YY, hh:mm A')
                                            : '-'}
                                    </ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Email</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.email ? selectedData.email : '-'}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            {/* <ModalRow className="pb-4"> */}
                            <FlexCol className="pb-4">
                                <ModalRowLabel>Interested Property</ModalRowLabel>
                                <ModalRowValue>
                                    {selectedData?.linkedProperties?.length > 0 ? (
                                        <div className="flex flex-wrap gap-2">
                                            {selectedData.linkedProperties.map((prop, index) => (
                                                <span key={prop.id} className="bg-blue-50 text-primary-color py-1 px-2 rounded-lg">
                                                    {prop.name}
                                                </span>
                                            ))}
                                        </div>
                                    ) : (
                                        <span className="text-gray-400">-</span>
                                    )}
                                </ModalRowValue>
                            </FlexCol>
                            <FlexCol className="pb-4">
                                <ModalRowLabel>Assign Staff</ModalRowLabel>
                                <ModalRowValue>
                                    {selectedData?.linkedStaffs?.length > 0 ? (
                                        <div className="flex flex-wrap gap-2">
                                            {selectedData.linkedStaffs.map((prop, index) => (
                                                <span key={prop.id} className="bg-blue-50 text-primary-color py-1 px-2 rounded-lg">
                                                    {prop.name}
                                                </span>
                                            ))}
                                        </div>
                                    ) : (
                                        <span className="text-gray-400">-</span>
                                    )}
                                </ModalRowValue>
                            </FlexCol>
                            {/* </ModalRow> */}
                        </ModalSection>
                    </Wrapper>
                    {selectedData?.notes?.length > 0 && (
                        <Wrapper>
                            <BtnWrapper>
                                <SectionTitle>Notes</SectionTitle>
                            </BtnWrapper>
                            <FlexCol>
                                {/* <ModalRowLabel>Notes</ModalRowLabel> */}
                                <div >
                                    {selectedData?.notes.map((note, index) => (
                                        <NoteItem
                                            key={index}
                                            name={note.doneByName}
                                            time={note.createdAt}
                                            description={note?.notes || ''}
                                        />
                                    ))}
                                </div>
                            </FlexCol>
                        </Wrapper>)}
                </ScrollableContent>
            </ModalContent>
        </Container>
    );
};

const Wrapper = tw.div`grid gap-1.5 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const BtnWrapper = tw.div`w-full flex items-center justify-between `;
const FlexCol = tw.div`flex flex-col gap-0.5`
const UserImageWrapper = tw.div` flex items-center gap-2`;

export default ViewLead;
